import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import {TableHeaderRowProps} from 'react-virtualized'
import {ReportsTableContextProps} from 'modules/reports/components/Table/ReportsTable.context'

type Props = TableHeaderRowProps & ReportsTableContextProps

function ReportsTableHeaderRow(props: Props) {
  const {className, columns, style, tablePrefix, bag} = props
  const p = usePrefix(tablePrefix)

  return (
    <div className={className} role="row" style={style} data-testid={p('header-row')}>
      {bag && <div style={{width: '42px'}} />}
      {columns}
    </div>
  )
}

export default ReportsTableHeaderRow
